import Link from 'next/link';

export const getData = (onClickTypeSkin: () => void) => ({
  questions: [
    {
      title: 'Как присоединиться к Программе привилегий Brand?',
      answer:
        'Все зарегистрированные в Личном кабинете пользователи автоматически становятся участниками Программы привилегий и получают бонусы за покупки. Если у вас ещё нет Личного кабинета, просто зарегистрируйтесь — это займёт всего пару минут.'
    },
    {
      title: 'В каком случае начисляются баллы?',
      answer: (
        <>
          <p>
            Баллы начисляются за каждую покупку. Если это ваша первая покупка,
            вы получите повышенный кешбэк баллами 15%. Для следующих покупок
            размер кешбэка зависит от уровня в Программе привилегий:
          </p>
          <ul>
            <li>10% на первом уровне</li>
            <li>25% на втором уровне</li>
          </ul>
          <p>
            Размер кешбэка рассчитывается от итоговой суммы заказа после
            применения скидок.
          </p>
          <p>
            <strong>
              При частичной оплате бонусными баллами , новые баллы не
              начисляются.
            </strong>{' '}
            Начисляются баллы сразу после выполнения заказа (когда заказ
            приобретает статус “Выполнен”).
          </p>
        </>
      )
    },
    {
      title: 'В каком случае можно списать баллы?',
      answer: (
        <>
          <p>
            Вы можете оплатить баллами до 50% от суммы заказа, но после их
            списания итоговая стоимость корзины должна быть не менее 1 000 ₽.
            Баллы недоступны к списанию, если применен промокод на скидку.
          </p>
          <p>
            При списании баллов на товар с действующей скидкой расчет итоговой
            суммы осуществляется от изначальной цены - скидка и баллы не
            суммируются.
          </p>
        </>
      )
    },
    {
      title: 'Какие привилегии доступны при первой покупке?',
      answer: (
        <>
          <p>
            Если вы ещё не совершали покупки на сайте или в приложении, вам
            доступна акция: скидка 15% и кешбэк 15% баллами. Промокод на скидку
            придёт на ваш email, поэтому важно согласиться на получение
            рассылок. Промокод не распространяется на новинки, наборы и Age
            Proteom.
          </p>
          <p>
            Если вы уже делали покупки, действует стандартный кешбэк: 10% на
            первом уровне и 25% на втором.
          </p>
        </>
      )
    },
    {
      title: 'Какие преимущества вы можете получить в Программе привилегий?',
      answer: (
        <>
          <p>
            На первом уровне вы получаете 10% кешбэка баллами за каждую покупку.
            Также для вас открыты специальные акции — «секретные распродажи»,
            доступные только участникам Программы привилегий.
          </p>
          <p>
            На втором уровне кешбэк баллами увеличивается до 25% от суммы
            заказа. Дополнительно остаётся доступ к «секретным распродажам».
          </p>
        </>
      )
    },
    {
      title: 'Как перейти на 2 уровень?',
      answer: (
        <>
          <p>
            Чтобы повысить уровень, достаточно совершить покупки на сумму от 5
            000 ₽ в течение 180 дней и заполнить данные{' '}
            <button
              type="button"
              onClick={onClickTypeSkin}
              className="link underline underline-offset-4"
            >
              о вашем типе кожи в Личном кабинете
            </button>
            .
          </p>
        </>
      )
    },
    {
      title:
        'Я сделал заказ(ы) на сумму больше 5 000 ₽, но мой уровень не повысился. Почему?',
      answer: (
        <>
          <p>Чтобы перейти на 2 уровень, важно выполнить оба условия:</p>
          <ul>
            <li>Сумма ваших заказов за 180 дней должна быть от 5 000 ₽.</li>
            <li>
              В Личном кабинете должны быть заполнены данные{' '}
              <button
                type="button"
                onClick={onClickTypeSkin}
                className="link underline underline-offset-4"
              >
                о вашем типе кожи
              </button>
              .
            </li>
          </ul>
          <p>
            Проверьте, выполнены ли оба условия — это можно сделать в Личном
            кабинете. Если всё верно, но уровень не изменился, попробуйте
            подождать немного: обновление статуса может занять некоторое время.
          </p>
        </>
      )
    },
    {
      title: 'Почему мой уровень изменился?',
      answer: (
        <>
          <p>
            Если ваш уровень повысился с первого на второй — поздравляем! Это
            значит, что за последние 180 дней вы сделали покупки на сумму от 5
            000 ₽ и заполнили информацию о своем{' '}
            <button
              type="button"
              onClick={onClickTypeSkin}
              className="link underline underline-offset-4"
            >
              типе кожи в личном кабинете
            </button>
            . Теперь вам доступен кешбэк 25% баллами и другие привилегии.
          </p>
          <p>
            Если же уровень снизился обратно на первый, значит, за 180 дней
            сумма ваших заказов была меньше 5 000 ₽. Но вы всегда можете
            вернуться на 2 уровень, снова набрав нужную сумму покупок.
          </p>
        </>
      )
    },
    {
      title: 'Где я могу посмотреть все правила Программы привилегий Brand?',
      answer: (
        <>
          <p>
            Правила Программы привилегий вы можете изучить{' '}
            <Link
              href="#/upload/docs/%D0%9F%D0%9B_Brand_03.03.25.pdf"
              className="link underline underline-offset-4"
            >
              здесь
            </Link>
            .
          </p>
        </>
      )
    }
  ]
});
